
  import { Component, Vue } from 'vue-property-decorator'
  import { Tour, TourOptions } from '@/plugins/tour'
  import { WelcomeTour } from '@/plugins/tour/examples/WelcomeTour'

@Component({
  components: {
    Tour,
  },
})
  export default class GlobalTour extends Vue {
  // Tour activo actualmente
  activeTour: any = null;

  // Opciones generales para tours
  tourOptions: TourOptions = {
    showButtons: true,
    showProgress: true,
    showCloseButton: true,
    darkMode: false,
    backdropOpacity: 0.7,
  };

  /**
   * Inicia un tour específico
   * @param tour Tour a iniciar
   */
  startTour (tour: any): void {
    this.activeTour = tour

    // Dar tiempo para que se actualice el componente
    setTimeout(() => {
      if (this.$refs.globalTour) {
        try {
          (this.$refs.globalTour as any).start()
        } catch (error) {
          console.error('Error al iniciar el tour:', error)
        }
      } else {
        console.error('Error: Referencia al componente Tour no encontrada')
      }
    }, 100)
  }

  /**
   * Inicia el tour de bienvenida
   */
  startWelcomeTour (): void {
    // Verificar si el tour ya fue completado o omitido
    const tourCompleted = localStorage.getItem('tourHistory')
      ? JSON.parse(localStorage.getItem('tourHistory') || '{}')[WelcomeTour.id]?.completed : false
    const tourSkipped = localStorage.getItem('welcome-tour-skipped') === 'true'

    // Solo iniciar si no ha sido completado ni omitido
    if (!tourCompleted && !tourSkipped) {
      this.startTour(WelcomeTour)
    }
  }

  /**
   * Finaliza el tour actual
   */
  endTour (): void {
    if (this.$refs.globalTour) {
      (this.$refs.globalTour as any).end()
      this.activeTour = null
    }
  }

  /**
   * Obtiene referencia al componente de tour
   */
  getTourComponent (): any {
    return this.$refs.globalTour
  }
  }
